export default function IconVerified() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="40" viewBox="0 0 33 40" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.0882 6.23066C30.9308 6.52566 31.4938 7.32004 31.4938 8.21276V21.2719C31.4938 24.9218 30.1673 28.4059 27.8246 31.1053C26.6465 32.4646 25.1561 33.5231 23.5731 34.3792L16.7129 38.0851L9.84108 34.3773C8.25617 33.5212 6.76381 32.4646 5.5838 31.1034C3.23921 28.404 1.90881 24.918 1.90881 21.2642V8.21276C1.90881 7.32004 2.47182 6.52566 3.31441 6.23066L16.0053 1.77092C16.4565 1.61282 16.9481 1.61282 17.3974 1.77092L30.0882 6.23066Z"
                stroke="#184353"
                strokeWidth="2.89217"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6892 19.3297L15.3372 22.9797L22.853 15.4639"
                stroke="#FF5F39"
                strokeWidth="2.89217"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
